/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_DownloadInputs */

const en_mk_desktop_download = /** @type {(inputs: Mk_Desktop_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Desktop for Linux x64`)
};

const id_mk_desktop_download = /** @type {(inputs: Mk_Desktop_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Desktop Linux x64`)
};

/**
* | output |
* | --- |
* | "Download Desktop for Linux x64" |
*
* @param {Mk_Desktop_DownloadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_download = /** @type {((inputs?: Mk_Desktop_DownloadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_DownloadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_download(inputs)
	return en_mk_desktop_download(inputs)
});